import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

type Direction = 'left' | 'right' | 'up' | 'down';

@Component
export default class ClSlide extends Vue {
  /**
   * If `true` the animation is in it's completed state.
   */
  @Prop({
    type: Boolean
  })
  public in!: boolean;
  private computedIn: boolean = this.in;

  @Prop({
    type: String as () => Direction,
    default: 'down'
  })
  public direction!: Direction;

  @Watch('in')
  watchInProp(newVal: boolean) {
    this.computedIn = newVal;
  }
}
